import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { ButtonWithLoader, RFFormInput } from 'virtues-bootstrap';

import { FORM_NAMES } from 'constants/forms';
import FormError from 'components/FormError';

import validate from './validate';
import s from './styles.module.scss';

const LoginForm = ({ error, handleSubmit, pristine, submitting, t }) => (
  <form onSubmit={handleSubmit}>
    <Field
      name="username"
      component={RFFormInput}
      errorClassName={s.fieldError}
      label={t('login.virtuesId')}
      placeholder={t('login.virtuesId')}
      type="text"
      wrapperClassName={s.login}
    />
    <Field
      name="password"
      component={RFFormInput}
      errorClassName={s.fieldError}
      label={t('login.password')}
      placeholder="••••••••"
      type="password"
      wrapperClassName={s.password}
    />
    <ButtonWithLoader
      className={s.signIn}
      disabled={pristine}
      loading={submitting}
      stretch
      type="submit"
    >
      {t('login.signIn')}
    </ButtonWithLoader>
    {error && <FormError>{error}</FormError>}
  </form>
);

LoginForm.defaultProps = {
  error: undefined,
};

LoginForm.propTypes = {
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

const withForm = reduxForm({
  form: FORM_NAMES.login,
  validate,
});

export default compose(
  withTranslation(),
  withForm,
)(LoginForm);
